import styled from "styled-components";
import { CssRule } from "../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { UserMenuSectionBox } from "../../user-menu/user-menu/boxes/user-menu-section.box";

const UserDetailsSectionDefaultBox = styled(UserMenuSectionBox)`
    /* .account-box */
    padding: 2.5rem 1.5rem 1.5rem 1.5rem;
    ${CssRule.For.mobile.build()} &{
        padding: 2rem;
        line-height: 1;
    }
`;

/* 777 */
const UserDetailsSectionCasino777Box = styled(UserDetailsSectionDefaultBox)`
    /* .account-box */
    ${CssRule.For.mobile.build()} &{
        padding: 1rem;
        margin: 1rem 0 0 0;
        &::before {
            display: none;
        }
    }
`;

/* harrahs */
/* wsop */
const UserDetailsSectionHarrahsWsopBox = styled(UserDetailsSectionDefaultBox)`
    /* .account-box */
    ${CssRule.For.mobile.build()} &{
        padding: 2rem;
        margin-top: 1rem;
    }
`;

export const UserDetailsSectionBox = styledByTheme(UserDetailsSectionDefaultBox)
    .forCasino777(UserDetailsSectionCasino777Box)
    .forHarrahs(UserDetailsSectionHarrahsWsopBox)
    .forWsop(UserDetailsSectionHarrahsWsopBox)
    .apply();
